var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6022 16.0268V19.4H6.6V4.6H17.4V19.4H13.4152V16.0268V15.4268H12.8152H11.2022H10.6022V16.0268Z",
    stroke: "#777",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70039 9.20205V7.60205H10.9004V9.20205H9.70039Z",
    fill: "#777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0998 9.20205V7.60205H14.2998V9.20205H13.0998Z",
    fill: "#777"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70039 12.4506V10.8506H10.9004V12.4506H9.70039Z",
    fill: "#777"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0998 12.4506V10.8506H14.2998V12.4506H13.0998Z",
    fill: "#777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoor);
export default __webpack_public_path__ + "static/media/indoor.e629a71096689de785195b42d26800b1.svg";
export { ForwardRef as ReactComponent };